module.exports = __webpack_public_path__ + "static/media/shower.c1550390.png";